import { useContext } from 'react';
import { Text } from '@shared/components/Text';
import { ColorThemeContext } from '@shared/styles';

interface Props {
  label?: string | null;
}

export function MBBlockLabel({ label }: Props) {
  const colors = useContext(ColorThemeContext);

  return (
    <Text size="overline" weight="semibold" color={colors.input.label}>
      {label?.toUpperCase() ?? ''}
    </Text>
  );
}
